'use strict';

DoohApps
.directive('backgroundImg', [function () {
    return function (scope, element, attrs) {
        element.css({
            'background-size': 'cover',
            'background-position': 'center center',
            'background-repeat': 'no-repeat'
        });
        attrs.$observe('backgroundImg', function (value) {
            if (value) {
                element.css({
                    'background-image': 'url(' + attrs.backgroundImg + ')',
                    'width': attrs.imgWidth,
                    'height': attrs.imgHeight
                });
            }
            else {
                element.css({
                    'background-image': 'url()',
                    'width': 0,
                    'height': 0
                });
            }
        });
    };
}]);